import { createContext, useContext } from 'react';

export const SlideContext = createContext(null);

export const useSlide = () => {
	return useContext(SlideContext);
};

export const SliderContext = createContext(null);

export const useSlider = () => {
	return useContext(SliderContext);
};
